<template>
  <div>
    <slot>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'SuiSampleDataset',
  props: {
    datacount: {
      type: Number,
      default: 4,
    },
  },
  data() {
    return {
      localdata0: [{
        deleteYn: 'Y',
        firstRegistrationDTM: '20190510125920',
        firstRegistrationUserId: 'chiwoo.seo',
        firstRegistrationProgramId: 'PGE_CMU_00001',
        finalModificationDTM: '2019-05-10 12:59:20',
        finalModificationUserId: 'chiwoo.seo',
        finalModificationProgramId: 'PGE_CMU_00001',
        pageId: 'PGE_CMS_00000',
        moduleCode: 'CM',
        subModuleCode: 'S',
        pageName: '배치작업이력',
        pageTitleMessageResourceId: 'MSG_CM_TIT_BCJB_HIS',
        pageTypeCode: 'N',
        pageDestinationValue: '/CM/pages/S/PGE_CMS_00005.vue',
        pageStatusCode: 'D',
        pageBlockContent: '차단된 페이지입니다.',
        pageUseYn: 'Y',
        pageUsePriodYn: 'N',
        pageUsePriodStartDatetime: '2019-05-10',
        pageUsePriodFinishDatetime: '9999-12-31',
        pagePopupYn: 'Y',
        pagePopupOptionValue: null,
        searchPageCond: null,
        searchPageText: null,
        lang: 'en',
        rangeDate: '2019-01-10~2019-02-15',
        buttonList: [{
          label: 'link',
          key: 'btn01',
          type: 'link',
        }, {
          label: 'sublink',
          key: 'btn02',
          type: 'sublink',
        }],
        time: '11:52',
        state: 'complete',
        multiselect: ['item01', 'item02'],
        amount: 10,
      },
      {
        deleteYn: 'Y',
        firstRegistrationDTM: '20190510125920',
        firstRegistrationUserId: 'chiwoo.seo',
        firstRegistrationProgramId: 'PGE_CMU_00003',
        finalModificationDTM: '2019-05-10 12:59:20',
        finalModificationUserId: 'chiwoo.seo',
        finalModificationProgramId: 'PGE_CMU_00003',
        pageId: 'PGE_CMS_00001',
        moduleCode: 'CM',
        subModuleCode: 'S',
        pageName: '배치작업이력',
        pageTitleMessageResourceId: 'MSG_CM_TIT_BCJB_HIS',
        pageTypeCode: 'N',
        pageDestinationValue: '/CM/pages/S/PGE_CMS_00005.vue',
        pageStatusCode: 'D',
        pageBlockContent: '차단된 페이지입니다.',
        pageUseYn: 'N',
        pageUsePriodYn: 'N',
        pageUsePriodStartDatetime: '2019-05-11',
        pageUsePriodFinishDatetime: '9999-12-30',
        pagePopupYn: 'N',
        pagePopupOptionValue: null,
        searchPageCond: null,
        searchPageText: null,
        lang: 'en',
        rangeDate: '2019-01-11~2019-02-16',
        buttonList: [{
          label: 'btn21',
          key: 'btn01',
          type: 'positive',
        }, {
          label: 'btn22',
          key: 'btn02',
          type: 'negative',
        }],
        time: '12:12',
        state: 'waiting',
        multiselect: ['item01', 'item03'],
        amount: 12,
      },
      {
        deleteYn: 'N',
        firstRegistrationDTM: '20190510125920',
        firstRegistrationUserId: 'chiwoo.seo',
        firstRegistrationProgramId: 'PGE_CMU_00005',
        finalModificationDTM: '2019-05-10 12:59:20',
        finalModificationUserId: 'chiwoo.seo',
        finalModificationProgramId: 'PGE_CMU_00005',
        pageId: 'PGE_CMS_00002',
        moduleCode: 'CM',
        subModuleCode: 'S',
        pageName: '배치작업이력',
        pageTitleMessageResourceId: 'MSG_CM_TIT_BCJB_HIS',
        pageTypeCode: 'N',
        pageDestinationValue: '/CM/pages/S/PGE_CMS_00005.vue',
        pageStatusCode: 'D',
        pageBlockContent: '차단된 페이지입니다.',
        pageUseYn: 'Y',
        pageUsePriodYn: 'N',
        pageUsePriodStartDatetime: '2019-05-13',
        pageUsePriodFinishDatetime: '9999-12-30',
        pagePopupYn: 'N',
        pagePopupOptionValue: null,
        searchPageCond: null,
        searchPageText: null,
        lang: 'en',
        rangeDate: '2019-01-12~2019-02-17',
        buttonList: [{
          label: 'btn33',
          key: 'btn01',
          type: 'positive',
        }, {
          label: 'btn32',
          key: 'btn02',
          type: 'negative',
        }, {
          label: 'btn01',
          key: 'btn02',
          type: 'negative',
        }],
        time: '14:52',
        state: 'cancel',
        multiselect: ['item02', 'item04'],
        amount: 15,
      },
      {
        deleteYn: 'N',
        firstRegistrationDTM: '20190510125920',
        firstRegistrationUserId: 'chiwoo.seo',
        firstRegistrationProgramId: 'PGE_CMU_00002',
        finalModificationDTM: '2019-05-10 12:59:20',
        finalModificationUserId: 'chiwoo.seo',
        finalModificationProgramId: 'PGE_CMU_00002',
        pageId: 'PGE_CMS_00003',
        moduleCode: 'CM',
        subModuleCode: 'S',
        pageName: '배치작업이력',
        pageTitleMessageResourceId: 'MSG_CM_TIT_BCJB_HIS',
        pageTypeCode: 'N',
        pageDestinationValue: '/CM/pages/S/PGE_CMS_00005.vue',
        pageStatusCode: 'D',
        pageBlockContent: '차단된 페이지입니다.',
        pageUseYn: 'N',
        pageUsePriodYn: 'N',
        pageUsePriodStartDatetime: '2019-05-14',
        pageUsePriodFinishDatetime: '9999-12-30',
        pagePopupYn: 'N',
        pagePopupOptionValue: null,
        searchPageCond: null,
        searchPageText: null,
        lang: 'en',
        rangeDate: '2019-01-14~2019-02-18',
        buttonList: [{
          label: 'btn44',
          key: 'btn01',
          type: 'positive',
        }, {
          label: 'btn42',
          key: 'btn02',
          type: 'negative',
        }, {
          label: 'btn01',
          key: 'btn02',
          type: 'negative',
        }],
        time: '17:17',
        state: 'before-complete',
        multiselect: ['item03'],
        amount: 20,
      },
      ],
    };
  },
  created() {
    const newData = [];
    for (let i = 0; i < this.datacount; i += 1) {
      newData.push(_.clone(this.localdata0[i % 4]));
    }
    this.localdata0 = newData;
    // this.datasetsample.setRawData(newData);
  },
  datasets: [{
    id: 'datasetsample',
    type: 'local',
    data: 'localdata0',
    datafields: [{
      name: 'deleteYn',
      type: 'string',
      map: 'deleteYn',
    },
    {
      name: 'firstRegistrationDTM',
      type: 'string',
      map: 'firstRegistrationDTM',
    },
    {
      name: 'firstRegistrationUserId',
      type: 'string',
      map: 'firstRegistrationUserId',
    },
    {
      name: 'firstRegistrationProgramId',
      type: 'string',
      map: 'firstRegistrationProgramId',
    },
    {
      name: 'finalModificationDTM',
      type: 'string',
      map: 'finalModificationDTM',
    },
    {
      name: 'finalModificationUserId',
      type: 'string',
      map: 'finalModificationUserId',
    },
    {
      name: 'finalModificationProgramId',
      type: 'string',
      map: 'finalModificationProgramId',
    },
    {
      name: 'pageId',
      type: 'string',
      map: 'pageId',
    },
    {
      name: 'moduleCode',
      type: 'string',
      map: 'moduleCode',
    },
    {
      name: 'subModuleCode',
      type: 'string',
      map: 'subModuleCode',
    },
    {
      name: 'pageName',
      type: 'string',
      map: 'pageName',
    },
    {
      name: 'pageTitleMessageResourceId',
      type: 'string',
      map: 'pageTitleMessageResourceId',
    },
    {
      name: 'pageTypeCode',
      type: 'string',
      map: 'pageTypeCode',
    },
    {
      name: 'pageDestinationValue',
      type: 'string',
      map: 'pageDestinationValue',
    },
    {
      name: 'pageStatusCode',
      type: 'string',
      map: 'pageStatusCode',
    },
    {
      name: 'pageBlockContent',
      type: 'string',
      map: 'pageBlockContent',
    },
    {
      name: 'pageUseYn',
      type: 'string',
      map: 'pageUseYn',
    },
    {
      name: 'pageUsePriodYn',
      type: 'string',
      map: 'pageUsePriodYn',
    },
    {
      name: 'pageUsePriodStartDatetime',
      type: 'string',
      map: 'pageUsePriodStartDatetime',
    },
    {
      name: 'pageUsePriodFinishDatetime',
      type: 'string',
      map: 'pageUsePriodFinishDatetime',
    },
    {
      name: 'pagePopupYn',
      type: 'string',
      map: 'pagePopupYn',
    },
    {
      name: 'pagePopupOptionValue',
      type: 'string',
      map: 'pagePopupOptionValue',
    },
    {
      name: 'searchPageCond',
      type: 'string',
      map: 'searchPageCond',
    },
    {
      name: 'searchPageText',
      type: 'string',
      map: 'searchPageText',
    },
    {
      name: 'lang',
      type: 'string',
      map: 'lang',
    },
    {
      name: 'rangeDate',
      type: 'string',
      map: 'rangeDate',
    },
    {
      name: 'buttonList',
      type: 'object',
      map: 'buttonList',
    },
    {
      name: 'state',
      type: 'object',
      map: 'state',
    },
    {
      name: 'dataset-row-id',
      type: 'string',
      map: 'dataset-row-id',
    },
    {
      name: 'pageName1',
      type: 'string',
      map: 'pageName1',
    },
    {
      name: 'pageName2',
      type: 'string',
      map: 'pageName2',
    },
    {
      name: 'pageName3',
      type: 'string',
      map: 'pageName3',
    },
    {
      name: 'pageName4',
      type: 'string',
      map: 'pageName4',
    },
    {
      name: 'pageName5',
      type: 'string',
      map: 'pageName5',
    },
    {
      name: 'amount',
      type: 'string',
      map: 'amount',
    }],
  }],
  methods: {
  },
};
</script>
